import type { BathroomEvent } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getBathroomEvents = async (
  roomId: string,
  start: string,
  end: string,
) => {
  const url = `/eventReview/v1/bathroomEvents/${roomId}/${start}/${end}`;
  const res = await Api.get<BathroomEvent[]>(url);
  return res && res.data;
};
